import { InputStateInterface } from 'common/module/input/state.interface';
import { InputValidatorInterface } from 'common/module/input/validator.interface';

export class InputValidatorPropertyId implements InputValidatorInterface {
  /**
   * Constructor
   */
  constructor(protected propertyDetailUrl: string) {}

  /**
   * @inheritDoc
   */
  public getError(value: string, context: { [key: string]: InputStateInterface }): string {
    return !value.match(/-(\d*)\.html/) ? this.propertyDetailUrl : '';
  }
}
